import { API } from '../../API';

export type NeuralSearchAction = 'GENERATE' | 'APPLY_TOPIC';
export type FeedbackType = 'POSITIVE' | 'NEGATIVE';
export type TipType = 'COUNTRIES' | 'DATES' | 'FILTER' | 'TRANSLATE' | 'GENERAL';

export interface Topic {
  name: string;
  description: string | null;
}

export interface Tip {
  text: string[];
  title?: string;
  message?: string;
}

export interface NeuralSearchRequest {
  session_id?: string;
  action: NeuralSearchAction;
  prompt: string;
  current_query?: string | null;
  original_prompt?: string | null;
}

export interface NeuralSearchResponse {
  query: string;
  id: number;
  topics?: Topic[];
  tips?: string[];
}

export interface FeedbackRequest {
  id: number;
  feedback: FeedbackType;
}


export const neuralSearchAPI = {
  async sendPrompt(
    request: NeuralSearchRequest,
    signal?: AbortSignal
  ): Promise<NeuralSearchResponse> {
    return await API.fetch(
      'POST',
      '/API/v2/neural-search',
      null,
      request,
      signal
    );
  },

  async sendFeedback(request: FeedbackRequest): Promise<string> {
    return await API.fetch(
      'PATCH',
      '/API/v2/neural-search/feedback',
      null,
      request
    );
  },
};
